import logo from './logo.svg';
import './App.css';
import HomeWrapper from './components/wrappers/HomeWrapper';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Login from './pages/Login';
import Footer from './components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import Error from './pages/Error';
import Default from './pages/Default';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Default />}/>
          <Route path='/:vendorId' element={<Login/>}/>
          <Route path='/dashboard/' element={<HomeWrapper/>}/>
          <Route path='/error' element={<Error/>}/>
        </Routes>
      </Router>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
      />
      <Footer/>
    </>
  );
}

export default App;